import Lab from '../Lab';

import { useContext, useEffect, useRef, useState } from 'react';
import PageContext from '../Context/PageContext';
import TextElement from './Element/TextElement';

import { PDFDownloadLink, Document, Page, Canvas, View, Text } from '@react-pdf/renderer';

import { Rnd } from "react-rnd";

import interact from 'interactjs'

import $ from "jquery";
import 'jquery-ui/ui/widgets/resizable';
import MoveCard from './Card/MoveCard';
import StyloCard from './Card/StyloCard';
import CropCadreImageCard from './Card/CropCadreImageCard';
import CropImageCard from './Card/CropImageCard';
import HistoryShortcuts from '../history/HistoryShortcuts';
import { createDeleteElementAction } from '../history/element.history';

export default function Editor() {

    const { objItems, setObjItems, cropCadreImage, setCropCadreImage, cropImage, setCropImage, zoomValue,
        pageSize, pageColor, page, setPage, history, addItem, selectedItem, setSelectedItem, removeItem, setIsOpenOpacity, setOpenAbsoluteMenuSection } = useContext(PageContext);

    const pageRef = useRef(null);

    function handleEnterKeyDown() {
        document.addEventListener("keydown", keyDownFunction, false);
    }

    /* Gestion suppression d'un élément*/
    function keyDownFunction(event: any) {

        //de base on peut supprimer les element text, sauf si ils sont en edition
        var isTextEditable = false;

        if (selectedItem != null && selectedItem.classList.contains('text-element')) {
            var el = document.querySelector('#' + selectedItem.id + ' .text-element-content')
            if(el !=null)  isTextEditable = el.getAttribute('contenteditable') === "true" ? true :false;
        }

        // enter keycode is 46 delete keybord
        if (event.keyCode == 46) {

            //on peut supprimer le text element si  on pas en edition
            if (selectedItem != null && removeItem != null && !isTextEditable) {
                if (setSelectedItem != null) setSelectedItem(null);

                removeItem(selectedItem['id']);

                //handle history
                var item = objItems.find(item => item.id === selectedItem.id);
                const action = createDeleteElementAction(item, { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, addItem, setObjItems, objItems });
                history.add(action);
            }
        }
    }

    useEffect(() => {
        if (setPage != null) setPage(pageRef);
        handleEnterKeyDown();

        return () => {
            document.removeEventListener("keydown", keyDownFunction, false);
        }

    }, [selectedItem])

    /* SUPER IMPORTANT to set key with id, for remove later*/
    const textI = objItems.map((textItem: any, index) =>
        <TextElement key={textItem.id} val={textItem} index={index} />
    );

    const textIClone = objItems.map((textItem: any, index) =>

        <div key={textItem.id} id={'clone-container-' + textItem.id} style={{ touchAction: 'none', position: 'relative' }}>
            {selectedItem != null && selectedItem.id == textItem.id &&
                <MoveCard val={textItem}></MoveCard>
            }
            {selectedItem != null && selectedItem.id == textItem.id && textItem.type == "text-element" &&
                <StyloCard val={textItem}></StyloCard>
            }
            <div key={textItem.id} id={'clone-' + textItem.id} style={{ touchAction: 'none' }}></div>
        </div>
    );

    function unSelectElement(event: React.MouseEvent<HTMLElement>) {

        //eviter de désectionner le texte quand il est sélectionné
        var selection = window.getSelection() != null ? window.getSelection()?.anchorOffset : 0;

        var idSelectedElement = (event.target as Element).id;
        if ((idSelectedElement === 'page' || idSelectedElement === 'editor') && selection != undefined && selection <= 0) {
            //$('.selected-element').removeClass("selected-element");
            //Cas spécial pour l'élément texte, on supprime les bordures active
            $('.text-eleme-active').remove();


            //close crop image card
            if (setCropImage != null) {
                setCropImage(null);
                if (selectedItem != null) {
                    //avec cropImage on créer une copie de l'élément image, si on le ferme, on remet l'image initiale et son clone container que l'on masqué
                    $("#" + selectedItem.id).css('visibility', 'visible');
                    $("#clone-container-" + selectedItem.id).css('display', 'block');
                }
            }

            //set selectedItem context to null !
            if (selectedItem != null && setSelectedItem != null) {
                setSelectedItem(null);
            }

            //close collapse opacity
            if (setIsOpenOpacity != null) setIsOpenOpacity(false)
            //close position section
            if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection('')
            //close (delete) cropCadre card and show img
            if (cropCadreImage != null) $("#img-" + cropCadreImage.originalId).css('visibility', 'visible');
            if (setCropCadreImage != null) setCropCadreImage(null)

        }
    }

    const style = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "solid 1px #ddd",
        background: "#f0f0f0"
    } as const;

    return (
        <div className='editor' id='editor' onClick={unSelectElement} style={{/*transformOrigin: 'center center'*/ }}>
            <div className='page' id='page' ref={pageRef} style={{ height: pageSize.height + 'px', width: pageSize.width + 'px', backgroundColor: pageColor }}>
                <Lab />
                {textI}
                {textIClone}
                {cropCadreImage != null && <CropCadreImageCard val={cropCadreImage} itemToCrop={selectedItem} />}
                {cropImage != null && <CropImageCard val={cropImage} itemToCrop={selectedItem} />}
                <div id={'clone-mapbox-id'} style={{ touchAction: 'none' }}></div>
                <HistoryShortcuts />
            </div>
        </div>

    );
}